import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { linkedinPostApi } from './linkedinPostApi';
import type {
  LinkedinPost,
  LinkedinPostCreatePayload,
  LinkedinPostUpdatePayload,
} from './linkedinPostTypes';

const thunks = createCrudThunks<
  LinkedinPost,
  LinkedinPostCreatePayload,
  LinkedinPostUpdatePayload,
  ServerListParams
>('linkedinPosts', linkedinPostApi);

export const linkedinPostThunks = thunks;
export const {
  fetchAll: fetchLinkedinPosts,
  fetchOne: fetchLinkedinPost,
  create: createLinkedinPost,
  update: updateLinkedinPost,
  remove: deleteLinkedinPost,
} = thunks;
